import clsx from 'clsx';
import { useField } from 'formik';
import React, { useEffect } from 'react';
import Switch from 'react-switch';

import { Theme } from '@interfaces/global';

interface SwitchFieldProps {
  colorTheme?: Theme;
  className?: string;
  id?: string;
  disabled?: boolean;
  label?: string;
  name: string;
  onChangeCallBack?: ({ checked, id }: { checked: boolean; id?: string }) => void;
}

const SwitchField = ({
  colorTheme = Theme.Light,
  className,
  disabled = false,
  id,
  label,
  name,
  onChangeCallBack,
}: SwitchFieldProps) => {
  const [field, , helpers] = useField(name);

  // optional callback to trigger after field gets changed.
  useEffect(() => {
    if (onChangeCallBack) {
      onChangeCallBack({ checked: field.value, id });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [field.value]);

  return (
    <div className={clsx('flex items-center', className)}>
      <Switch
        className="switch mr-8"
        id={id}
        name={name}
        width={48}
        height={24}
        offColor={colorTheme === 'dark' ? '#6D686E' : '#F0ECE5'}
        offHandleColor={colorTheme === 'dark' ? '#F0ECE5' : '#000'}
        onColor="#FEC6CC"
        onHandleColor="#F32A52"
        uncheckedIcon={false}
        checkedIcon={false}
        checked={field.value}
        disabled={disabled}
        onChange={(checked) => {
          helpers.setValue(checked);
        }}
      />
      {label && (
        <label
          htmlFor={id}
          className={clsx('max-w-full font-suisse-intl text-icon-sm sm:max-w-[310px]', {
            'text-grayscale-charcoal': colorTheme === 'light',
            'text-grayscale-beige': colorTheme === 'dark',
          })}
        >
          {label}
        </label>
      )}
    </div>
  );
};

export default SwitchField;
